/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Oid from './Oid';

/**
 * The X500DistinguishedName model module.
 * @module model/X500DistinguishedName
 * @version V1
 */
class X500DistinguishedName {
    /**
     * Constructs a new <code>X500DistinguishedName</code>.
     * @alias module:model/X500DistinguishedName
     */
    constructor() { 
        
        X500DistinguishedName.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>X500DistinguishedName</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/X500DistinguishedName} obj Optional instance to populate.
     * @return {module:model/X500DistinguishedName} The populated <code>X500DistinguishedName</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new X500DistinguishedName();

            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
            if (data.hasOwnProperty('oid')) {
                obj['oid'] = Oid.constructFromObject(data['oid']);
            }
            if (data.hasOwnProperty('rawData')) {
                obj['rawData'] = ApiClient.convertToType(data['rawData'], 'Blob');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>X500DistinguishedName</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>X500DistinguishedName</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
            throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
        }
        // validate the optional field `oid`
        if (data['oid']) { // data not null
          Oid.validateJSON(data['oid']);
        }

        return true;
    }


}



/**
 * @member {String} name
 */
X500DistinguishedName.prototype['name'] = undefined;

/**
 * @member {module:model/Oid} oid
 */
X500DistinguishedName.prototype['oid'] = undefined;

/**
 * @member {Blob} rawData
 */
X500DistinguishedName.prototype['rawData'] = undefined;






export default X500DistinguishedName;

